import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Popover,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../../context/AuthProvider";
import { HttpService } from "../../../service/HttpService";
import dayjs from "dayjs";
import { FaFilter } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";
import DateTimeModal from "../../Schedule/ScheduleListAdd/DateTimeModal";
import { handleDownloadHistoryExcel } from "./DownloadHistoryExcel";
import { GridMoreVertIcon } from "@mui/x-data-grid";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import QtyModal from "../QtyModal/QtyModal";
import { toast } from "react-toastify";
import DeleteModal from "../../../components/Model/DeleteModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 3,
  outline: "unset",
};

const HistoryModal = ({ open, handleClose, id }) => {
  const historyDateFilter = localStorage.getItem("historyDateFilter");
  const dateFilterData = historyDateFilter
    ? JSON.parse(historyDateFilter)
    : null;
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(dateFilterData?.startDate || "");
  const [endDate, setEndDate] = useState(dateFilterData?.endDate || "");
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );
  const [label, setLabel] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [openPurchaseModal, setOpenPurchaseModal] = useState(false);
  const [itemsData, setItemsData] = useState({});
  const [transHistory, setTransHistory] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState(null);
  const [deleteIntTransHistory, setDeleteIntTransHistory] = useState("");

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setDataId(id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setDataId(null);
  };

  const radioOptions = [
    { value: "today", label: "Today" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
    { value: "specific", label: "Specific Date Range" },
  ];

  const handleRadioChange = () => {
    const setlabel =
      radioOptions.find((option) => option.value === selectedRadio)?.label ||
      "";
    setLabel(setlabel);
  };

  const fetchHistory = () => {
    setLoading(true);
    httpService
      .get(
        `inventory/transactions/${id}?start_date=${startDate}&end_date=${endDate}`
      )
      .then((response) => {
        setHistoryData(response?.data?.history);
        setItemsData(response?.data?.inventory[0]);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const HandleDeleteIntTransHistory = async () => {
    if (deleteIntTransHistory) {
      try {
        const response = await httpService.delete(
          `${"inventory/transactions"}/${deleteIntTransHistory}`
        );
        if (response) {
          fetchHistory();
          toast.success("Inventory Transaction Deleted successfully", {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchHistory();
      } catch (error) {
        setOpenDelete(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  useEffect(() => {
    // const historyDateFilter = localStorage.getItem("historyDateFilter");
    // const dateFilterData = historyDateFilter
    //   ? JSON.parse(historyDateFilter)
    //   : null;
    // if (dateFilterData) {
    //   setStartDate(dateFilterData?.startDate);
    //   setEndDate(dateFilterData?.endDate);
    //   setSelectedRadio(dateFilterData?.selectedRadio);
    // } else {
    //   const dateFilter = {
    //     startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    //     endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
    //     selectedRadio: "month",
    //   };
    //   localStorage.setItem("historyDateFilter", JSON.stringify(dateFilter));
    // }
    fetchHistory();
  }, []);

  // useEffect(() => {
  //   handleRadioChange();
  // }, []);

  const onDownloadClick = async () => {
    try {
      await handleDownloadHistoryExcel(
        id,
        setShowLoginPopup,
        startDate,
        endDate
      );
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="h6">History</Typography>
              <Typography variant="h6">{label ? `(${label})` : ""}</Typography>
            </Box>
            <Box display={"flex"} alignItems="center">
              <button
                type="submit"
                variant="primary"
                className=""
                onClick={() => onDownloadClick(true)}
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                  marginRight: "5px",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "1px solid transparent",
                }}
              >
                <HiDownload size={22} />
              </button>
              <button
                type="submit"
                className="filter-btn-custm"
                onClick={() => setOpenDateModal(true)}
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                  marginRight: "5px",
                }}
              >
                <FaFilter />
              </button>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <strong>Action</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Purchased Qty</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Unit</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Total Price</strong>
                  </TableCell>
                  {/* <TableCell>
                    <strong>Used Qty</strong>
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {historyData.map((row, index) => (
                  <TableRow key={index}>
                    {/* --- Action column with Popover --- */}
                    <TableCell align="center">
                      <IconButton
                        onClick={(e) => handleMenuClick(e, row.id)}
                        size="small"
                      >
                        <GridMoreVertIcon />
                      </IconButton>

                      {dataId === row.id && (
                        <Popover
                          open={Boolean(anchorEl) && dataId === row.id}
                          anchorEl={anchorEl}
                          onClose={handleCloseMenu}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              setOpenPurchaseModal(true);
                              setTransHistory(row);
                              handleCloseMenu();
                            }}
                            className="menu-list-items"
                          >
                            <div className="menu-list-items-text">Edit</div>
                            <CiEdit style={{ cursor: "pointer" }} />
                          </MenuItem>

                          <MenuItem
                            onClick={() => {
                              setOpenDelete(true);
                              setDeleteIntTransHistory(row.id);
                              handleCloseMenu();
                            }}
                            className="menu-list-items"
                          >
                            <div className="menu-list-items-text">Delete</div>
                            <GoTrash style={{ cursor: "pointer" }} />
                          </MenuItem>
                        </Popover>
                      )}
                    </TableCell>
                    <TableCell>
                      {dayjs(row.date).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell>
                      {row.purchased_qty ? parseFloat(row.purchased_qty) : "-"}
                    </TableCell>
                    <TableCell>{row.unit ? row.unit : "-"}</TableCell>
                    <TableCell>
                      {row.total_price ? parseFloat(row.total_price) : "-"}
                    </TableCell>
                    {/* <TableCell>
                      {row.used_qty ? parseFloat(row.used_qty) : "-"}
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => setOpenDateModal(false)}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchHistory();
            const dateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "historyDateFilter",
              JSON.stringify(dateFilter)
            );
            handleRadioChange();
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}

      {openPurchaseModal && (
        <>
          <QtyModal
            open={openPurchaseModal}
            handleClose={() =>
              setOpenPurchaseModal((openPurchaseModal) => !openPurchaseModal)
            }
            itemDetails={itemsData}
            fetchInventory={() => fetchHistory()}
            history={transHistory}
          />
        </>
      )}

      <DeleteModal
        open={openDelete}
        HandleClose={() => setOpenDelete(false)}
        HandleDelete={() => {
          HandleDeleteIntTransHistory();
        }}
      />
    </>
  );
};

export default HistoryModal;
